module.exports = __webpack_public_path__ + "res/26-img_game_bg_t.e6035a7502d2da3dbc077bfd173432a2.png";